import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from '@thd-olt-component-react/router';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { useStore } from '../../../store/index';
import { HOME_PAGE_PATH } from '../../../utils/constants';
import { JobTemplatePageHeader } from './JobTemplatePageHeader';
import { JobTemplateList } from './JobTemplateList';
import { getPredefinedJobTemplates } from '../../../api/SlmService';
import { JobTemplateDetails } from './JobTemplateDetails/JobTemplateDetails';
import { JobTemplateDetailsHeader } from './JobTemplateDetails/JobTemplateDetailsHeader';
import { Spinner } from '../../../components/common/Spinner/Spinner';
import { pageLoadEvents } from '../../../utils/analytics';

const _JobTemplatePage = () => {

  const {
    authStore: {
      authorized,
      authInProgress
    }
  } = useStore();

  let { jobTemplateId } = useParams();

  const [jobTemplateData, setJobTemplateData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!authInProgress && !authorized) {
      /* istanbul ignore next */
      window.location.replace(`${HOME_PAGE_PATH}`);
    }
    pageLoadEvents.jobPostingsTemplatesPage();
  }, []);

  useEffect(() => {
    getPredefinedJobTemplates().then((res) => setJobTemplateData(res?.data)).finally(() => setIsLoading(false));
  }, []);

  const renderAllJobTemplates = () => {
    return (
      <>
        <ErrorBoundary name="job-template-page-header">
          <JobTemplatePageHeader />
        </ErrorBoundary>
        <ErrorBoundary name="job-template-list">
          <JobTemplateList jobTemplateData={jobTemplateData} />
        </ErrorBoundary>
      </>
    );
  };

  const renderJobTemplate = () => {

    const jobTemplate = Object.values(jobTemplateData)?.flat().find((template) => template?.jobTemplateId === Number(jobTemplateId));

    return (
      <>
        <Row>
          <Col xs={12} sm={8} md={8} lg={8} fallback={12}>
            <ErrorBoundary name="job-template-details-header">
              <JobTemplateDetailsHeader
                tradeType={jobTemplate?.tradeType}
                yearsOfExperience={jobTemplate?.yearsOfExperience}
              />
            </ErrorBoundary>
          </Col>
          <Col xs={12}>
            <ErrorBoundary name="job-template-details">
              <JobTemplateDetails jobTemplate={jobTemplate} />
            </ErrorBoundary>
          </Col>
        </Row>
      </>
    );
  };

  if (isLoading) {
    return <Spinner />;
  }
  return (
    <ErrorBoundary name="job-template-page">
      {!jobTemplateId && renderAllJobTemplates()}
      {jobTemplateId && renderJobTemplate()}
    </ErrorBoundary>
  );
};

export const JobTemplatePage = observer(_JobTemplatePage);
